<section class="kr-table__column" data-testid="mass_pay_out_item_num">
  {{ num() }}
</section>

<section
  class="kr-table__column"
  [title]="item().address"
  data-testid="mass_pay_out_item_from">
  <span
    class="kr-mass-pay-out-item__from"
    data-testid="mass_pay_out_item_from_value">
    {{ item().address }}
  </span>
</section>

<section class="kr-table__column" data-testid="mass_pay_out_item_to">
  <span
    class="kr-mass-pay-out-item__to"
    data-testid="mass_pay_out_item_to_value">
    {{ item().addressOut }}
  </span>

  <kr-copy-tooltip
    [text]="item().addressOut"
    data-testid="mass_pay_out_item_to_copy" />
</section>

<section
  class="kr-table__column kr-mass-pay-out-item__comment"
  data-testid="mass_pay_out_item_comment">
  @if (item().comment) {
    <kr-copy-tooltip
      data-testid="mass_pay_out_item_comment_tooltip"
      [text]="item().comment"
      [copy]="false"
      iconName="details" />
  }
</section>

@if (withStatus()) {
  <section
    class="kr-table__column kr-mass-pay-out-item__status"
    data-testid="mass_pay_out_item_status">
    @if (item().statusOriginal) {
      <kr-status
        data-testid="mass_pay_out_item_status_value"
        [type]="item().statusOriginal"
        i18nPrefix="dictionary.transactionStatuses" />

      @if (item().statusOriginal === 'rejected') {
        <kr-copy-tooltip
          [text]="'Transaction was rejected'"
          [copy]="false"
          data-testid="mass_pay_out_item_status_rejected_tooltip" />
      }
    }
  </section>
}

<section class="kr-table__column" data-testid="mass_pay_out_item_fee">
  <span
    class="kr-mass-pay-out-item__fee"
    data-testid="mass_pay_out_item_fee_value"
    [title]="
      item().fee || item().feeTotal
        | balanceFormat
          : wallet().secondaryWalletCoin?.symbol || wallet().coin?.symbol
    ">
    {{
      item().fee || item().feeTotal
        | balanceFormat
          : wallet().secondaryWalletCoin?.symbol || wallet().coin?.symbol
    }}
  </span>
  @if (isCryptoBanco()) {
    <kr-copy-tooltip
      data-testid="mass_pay_out_item_fee_tooltip"
      [text]="'massPayOutDetails.tooltip.fee' | translate"
      [copy]="false" />
  }
</section>

<section
  class="kr-table__column kr-mass-pay-out-item__amount"
  data-testid="mass_pay_out_item_amount"
  [title]="
    item().amount | balanceFormat: wallet().coin?.symbol | withDigitGroups
  ">
  {{ item().amount | balanceFormat: wallet().coin?.symbol | withDigitGroups }}
</section>

@if (withRiskScore() && !withStatus()) {
  <section
    class="kr-table__column kr-mass-pay-out-item__score"
    data-testid="mass_pay_out_item_score">
    @if (item()?.riskScoreError) {
      <kr-copy-tooltip
        data-testid="mass_pay_out_item_score_error_tooltip"
        [ngClass]="{
          'kr-mass-pay-out-item__score--error': !item()?.riskScorePassed,
        }"
        [text]="item()?.riskScoreError" />
    } @else {
      <kr-risk-score-value
        data-testid="mass_pay_out_item_score_value"
        [score]="item()?.riskScore"
        [level]="item()?.riskLevel" />
    }
  </section>
}
